import * as React from 'react'

const SuceessIcon = (props) => (
<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF"/>
<rect width="24" height="24" transform="translate(16 16)" fill="#D1FADF"/>
<path d="M36 22L25 33L20 28" stroke="#12B76A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<rect x="4" y="4" width="48" height="48" rx="24" stroke="#ECFDF3" strokeWidth="8"/>
</svg>
)

export default SuceessIcon
